<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <a-spin :spinning="confirmLoading">
      <j-form-container >
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
          <a-row>
            <a-col :span="24">
              <a-form-model-item :label="language['depart.management.departName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="oldDepartId">
                <a-input v-model="model.departName"  disabled ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="language['depart.management.oldFDepart']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="oldDepartId">
                <a-input v-model="model.oldDepartName"  disabled ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="language['depart.management.oldFDepartNo']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="oldDepartId">
                <a-input v-model="model.oldDepartNo"  disabled ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="language['depart.management.newFDepart']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="newDepartId">
                <a-input v-model="model.newDepartName"  disabled ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="language['depart.management.newFDepartNo']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="newDepartId">
                <a-input v-model="model.newDepartNo"  disabled ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="language['system.effectiveDate']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="effectiveDate">
                <!--<j-date placeholder="请选择生效日期" v-model="model.effectiveDate"  style="width: 100%" :disabled="model.status==='2'"/>-->
                <a-date-picker
                  style="width: 100%"
                  placeholder=""
                  v-model="model.effectiveDate"
                  :disabled-date="disabledDate"
                  :disabled="model.status!=='1'"
                  valueFormat="YYYY-MM-DD"
                  /> <!--:disabled="model.status==='2'||model.status==='4'"-->
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="language['depart.moveBtn']+language['common.status']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="status">
                <!--<a-input v-model="model.status" placeholder="请输入迁移状态"  ></a-input>-->
                <j-dict-select-tag v-model="model.status" dictCode="depart_move_status" disabled/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  import moment from "moment";
  import { httpAction } from '@/api/manage'
  export default {
    name: 'SysDepartMoveModal',
    components: {
    },
    computed:{
      language(){
        return this.$store.getters.language;
      },
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false,

        model:{
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/sys/sysDepartMove/add",
          edit: "/sys/sysDepartMove/edit",
          queryById: "/sys/sysDepartMove/queryById"
        }
      }
    },
    methods: {
      add () {
        this.visible=true
        this.edit();
        /*this.$nextTick(()=>{
          this.$refs.realForm.add();
        })*/
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible=true
        /*this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })*/
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        let getDate = new Date();
        let newStr = getDate.getFullYear()+'-'
          +(getDate.getMonth()+1>10?getDate.getMonth()+1:'0'+(getDate.getMonth()+1))+'-'
          +(getDate.getDay()>10?getDate.getDay():'0'+getDate.getDay());
        // let effectiveDateStr = that.model.effectiveDate.get("year")+'-'+(that.model.effectiveDate.get("month")+1)+'-'+that.model.effectiveDate.get("day")
        if(that.model.effectiveDate == newStr){
          that.$confirm({
            title: this.language["confirm.titleConfirmOperation"],
            content: this.language["system.departMove.sureSubmit"],
            onOk: function () {
              that.submitData(true);
            }
          })
        }else{
          that.submitData(false);
        }


      },
      submitData(isTransferDepart){
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            this.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let value = this.model;
            // value.status = '1';
            httpAction(httpurl,value,method).then((res)=>{
              if(res.success){
                this.$message.success(res.message);
                this.$emit('ok');
                this.visible = false;
                if(isTransferDepart){this.transferDepart(this.model.id)};
              }else{
                this.$message.warning(res.message);
              }
            }).finally(() => {
              this.confirmLoading = false;
            })
          }
        })
      },
      transferDepart(id){
        httpAction('/sys/sysDepart/transferDepartRightNow?id='+id,'','get').then((res)=>{
          if(res.success){
            this.$message.success(res.message);
          }else{
            this.$message.warning(res.message);
          }
          this.searchQuery()
        })
      },
      /*submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },*/
      handleCancel () {
        this.close()
      },
      disabledDate(current) {
        return current && current <= moment().endOf('day')-24*60*60*1000
      },
    }
  }
</script>